import * as React from 'react';
import { isEmpty } from 'lodash';

import TileStandard from 'components/tiles/standard/TileStandard';
import TileStandardLoading from 'components/tiles/standard/loading/TileStandardLoading';

import { getMostActiveState } from 'components/tabs/tabs-underlined/tabs-underlined-utils';

import type { InfluencerTile as InfluencerTileAlias, ListContextMenu } from 'types';
import type { RecentPostsDataType } from 'modules/influencers/types/RecentPosts.type';

type Props = {
  influencers: Array<InfluencerTileAlias>,
  influencerRecentPosts: {
    [x: number]: RecentPostsDataType
  },
  groupedCreatorIds: {
    [x: string]: Array<number>
  },
  expandedIdsMap: {
    [type: number]: string
  },
  contextMenuProps: ListContextMenu,
  updateCreatorTileSize?: (size: string, creatorId: number) => void,
  onDelete: (a: InfluencerTileAlias) => void,
  onFetchInfluencerPosts: (c: number, b: string, a: boolean) => void
};

const EXPANDED = 'expanded';
class ListsInfluencerCards extends React.PureComponent<Props> {
  renderInfluencerTileLoading(influencerId?: number | null): React.ReactNode {
    const { expandedIdsMap } = this.props;

    return (
      <TileStandardLoading
        key={`influencer-tile-loading-${String(influencerId)}`}
        tileSize={getMostActiveState(expandedIdsMap) || EXPANDED}
      />
    );
  }

  renderInfluencerTile(influencer: InfluencerTileAlias): React.ReactNode {
    const {
      influencerRecentPosts,
      groupedCreatorIds,
      expandedIdsMap,
      contextMenuProps,
      updateCreatorTileSize,
      onDelete,
      onFetchInfluencerPosts
    } = this.props;

    let channel = 'instagram';

    Object.keys(groupedCreatorIds).forEach(key => {
      if (groupedCreatorIds[key].includes(influencer.id)) {
        channel = key;
      }
    });

    return (
      <div
        key={influencer.id}
        className="lists-influencer-cards__item"
      >
        <TileStandard
          key={`lists-influencer-cards__tile-standard-${influencer.id}-${channel}`}
          creator={influencer}
          recentPosts={influencerRecentPosts[influencer.id]?.posts || []}
          hasMorePostsToLoad={influencerRecentPosts[influencer.id]?.hasMorePages ?? true}
          onFetchInfluencerPosts={onFetchInfluencerPosts}
          onDelete={onDelete}
          tileType="lists"
          channel={channel}
          globalTileSize={expandedIdsMap[influencer.id]}
          contextMenuProps={contextMenuProps}
          updateCreatorTileSize={updateCreatorTileSize}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    const { influencers, expandedIdsMap } = this.props;

    return (
      <section className="lists-influencer-cards">
        {
          influencers.map(influencer => {
            if (influencer.loading || isEmpty(expandedIdsMap) || expandedIdsMap[0]) {
              return this.renderInfluencerTileLoading(influencer.id);
            }

            return this.renderInfluencerTile(influencer);
          })
        }
      </section>
    );
  }
}

export default ListsInfluencerCards;
